export default __webpack_public_path__ + "static/media/boarding-service.d18d41eb.svg";